<template>
  <div style="z-index:600000">

      <ui-modal-old name="create-contact-modal">
        <template v-slot:icon>
          <i class="fas fa-user"></i>
        </template>
        <template v-slot:title>Create A Contact</template>

        <template v-slot:main>
          <crud-errors :errors="errors"></crud-errors>

          <dl>
            <dt>Title</dt>
            <dd><input type="text" v-model="new_item.title"/></dd>
            <dt>First Name</dt>
            <dd><input type="text" v-model="new_item.firstname"/></dd>
            <dt>Last Name</dt>
            <dd><input type="text" v-model="new_item.lastname"/></dd>
            <dt>Address</dt>
            <dd><textarea v-model="new_item.address"></textarea></dd>
            <dt>Postcode</dt>
            <dd><input type="text" v-model="new_item.postcode"/></dd>
            <dt>Email</dt>
            <dd><input type="email" v-model="new_item.email"/></dd>
            <dt>Phone</dt>
            <dd><input type="text" v-model="new_item.phone"/></dd>
            <dt>Phone (Secondary)</dt>
            <dd><input type="text" v-model="new_item.secondary_phone"/></dd>
            <dt>Avatar</dt>
            <dd><input type="file" ref="createAvatar"/></dd>
          </dl>

        </template>
        <template v-slot:buttons>
          <ui-button class="sm:ml-2" colour="green" @click.prevent="addItem()">
            <i class="fas fa-plus-circle mr-1"></i> Create Contact
          </ui-button>
        </template>
      </ui-modal-old>
  </div>
</template>

<script>
    export default {
        components: {},
        data() {
            return {
                name:'contacts',
                new_item:{},
                errors: null
            }
        },
        methods: {
            openModal(){
              this.new_item = {};
              this.resetErrors();
              window.eventBus.$emit('modal-open-create-contact-modal');
            },
            closeModal(){
              window.eventBus.$emit('modal-close-create-contact-modal');
              this.new_item = {};
              this.resetErrors();
            },
            resetErrors(){
                window.eventBus.$emit('crud-errors-dismissed');
            },
            addItem() {
                var that = this;
                var data = $.extend({}, this.new_item);
                var formDataObject = new FormData();

                _.forIn(data, function (value, key) {
                    formDataObject.append(key, value);
                });
                formDataObject.append('avatar', this.$refs.createAvatar.files[0]);

                axios.request({
                    method: 'post',
                    url: appUrls.contacts.store,
                    data: formDataObject,
                    config: {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }
                }).then(response => {
                    window.eventBus.$emit('contact-created',response.data.data);

                    that.closeModal();
                }).catch(function (error) {
                    if (error.response.status === 422) {
                        that.errors = error.response.data.errors;
                    }
                });
            },
            backToNav: function(){
                window.eventBus.$emit('crud-back-to-nav-'+this.name);
            }
        },
        mounted() {
            var that = this;

            window.eventBus.$on('create-new-contact', function () {
              that.openModal();
            });

            window.eventBus.$on('crud-errors-dismissed', function () {
                that.errors = null;
            });
        }
    }
</script>
